import React from "react"
import PropTypes from "prop-types"
import {
  Link
} from "react-router-dom"

import Wall         from './Wall'
import WindowCanvas from './WindowCanvas'

class LeftWall extends React.Component {
  render () {
    return (
      <Wall classnames={['wall-left']}>
        <WindowCanvas items               = {this.props.projectItems}
                      houseState          = {this.props.houseState}
                      xpos                = 'right'
                      padding             = {[1,0,0,0]} 
                      handleProjectHover  = {this.props.handleProjectHover}
                      handleCategoryHover = {this.props.handleCategoryHover}
                      currentProject      = {this.props.currentProject}
                      categoryId          = {this.props.categoryId}
        />
      </Wall>
    );
  }
}

LeftWall.propTypes = {
  data:               PropTypes.object,
  handleProjectHover: PropTypes.func
};

export default LeftWall
